<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M22.55 38.81l-13.7-13.7a9.76 9.76 0 01-.68-13.24 9.53 9.53 0 0113.92-.48L24 13.27l1.64-1.64a9.75 9.75 0 0113.2-.63 9.53 9.53 0 01.48 13.92L25.38 38.81a2 2 0 01-2.83 0zm-7.2-27.21a6.53 6.53 0 00-4.62 11.15L24 36l13.2-13.25a6.53 6.53 0 00-9.2-9.24l-4 4-4-4a6.49 6.49 0 00-4.65-1.91z"/></svg>